import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrendingGrid from './components/TrendingGrid';
import CategoryFeature from './components/CategoryFeature';
import CTADownload from './components/CTADownload';
import LatestArticles from './components/LatestArticles';
import { OrganizationSchema, WebSiteSchema, WebPageSchema } from '@/components/base/SeoSchema';

export default function Home() {
  return (
    <>
      <OrganizationSchema />
      <WebSiteSchema />
      <WebPageSchema
        title="51在线吃瓜入口 | 51在线吃瓜网站·51吃瓜官网全网最新"
        description="51在线吃瓜入口聚合51在线吃瓜网站、51吃瓜官网全网最新资源，提供51在线吃瓜app下载与吃瓜视频在线观看，一站式获取今日吃瓜黑料与网红爆料。"
        url="http://smallbar.cn/"
      />
      <Navbar />
      <main>
        <HeroSection />
        <TrendingGrid />
        <CategoryFeature />
        <CTADownload />
        <LatestArticles />
      </main>
      <Footer />
    </>
  );
}